import React from 'react';
import styled from 'styled-components';
import { COLORS, SIZES } from '../styleVars';
import { Typography } from '../typography/Typography';
var Container = styled.div.withConfig({
  componentId: "sc-1gu100x-0"
})(["padding:0.75rem 0.5rem;width:100%;min-height:5rem;display:flex;background-color:", ";border-radius:0.25rem;justify-content:center;"], COLORS.lightRed);
var MessageContainer = styled.div.withConfig({
  componentId: "sc-1gu100x-1"
})(["margin-left:0.5rem;flex:1;"]);
var Svg = styled.svg.withConfig({
  componentId: "sc-1gu100x-2"
})(["fill:currentColor;width:1em;height:1em;display:inline-block;font-size:", ";color:", ";flex-shrink:0;"], SIZES[24], COLORS.red);

var Error = function Error(_ref) {
  var errorCode = _ref.errorCode,
      errorMessage = _ref.errorMessage;
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Svg, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM12 17.3c-.72 0-1.3-.58-1.3-1.3 0-.72.58-1.3 1.3-1.3.72 0 1.3.58 1.3 1.3 0 .72-.58 1.3-1.3 1.3zm1-4.3h-2V7h2v6z"
  })), /*#__PURE__*/React.createElement(MessageContainer, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "body-strong"
  }, errorCode), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, errorMessage)));
};

export { Error };
//# sourceMappingURL=Error.js.map